import React, { useContext } from 'react';
import proptypes from 'prop-types';
const { string } = proptypes;
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { LoadingPlaceholder } from '../core/LoadingPlaceholder';
import { dynamicRecsDataModel } from '../dataModel';
import SearchViewedRecs from './SearchViewedRecs';

const SearchViewedWrapperComponent = ({ anchor = null, anchorId = null, ...rest }) => {
  const { isServer } = useContext(ExperienceContext);

  if (!isServer) {
    return (
    /* eslint-disable react/jsx-props-no-spreading */
      <SearchViewedRecs {...rest} anchor={anchor || anchorId} anchorId={anchorId} />
    );
  }
  return null;
};

SearchViewedWrapperComponent.displayName = 'SearchViewedWrapper';

const propTypes = {
  anchorId: string,
  schemaName: string.isRequired,
  anchor: string
};
const dataModel = dynamicRecsDataModel;

SearchViewedWrapperComponent.propTypes = propTypes;
SearchViewedWrapperComponent.dataModel = dataModel;

const HydratedSearchViewedRecs = withHydrator({
  delay: 1500,
  id: 'product-section-searchviewed',
  placeholder: (<LoadingPlaceholder />),
  preserveCtxVal: 'clientStore',
  scrollBuffer: 1200
}, SearchViewedWrapperComponent);

export const SearchViewedWrapper = withErrorBoundary(HydratedSearchViewedRecs);

SearchViewedWrapperComponent.propTypes = propTypes;
SearchViewedWrapper.dataModel = dataModel;
